var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMountains = function SvgIconMountains(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.344 12.46-5-8a1 1 0 0 0-1.7 0l-1 1.63-3.29-5.6a1 1 0 0 0-1.72 0l-7 12a1 1 0 0 0 .86 1.5h18a1 1 0 0 0 .85-1.53Zm-11.4-.47h-5.71l5.26-9 2.93 5-2.48 4Zm2.35 0 2.2-3.43 1-1.68 3.2 5.11h-6.4Z",
    fill: "currentColor"
  })));
};
export default SvgIconMountains;